import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';
import apiHelper from '../utils/apiHelper';

const NewsContext = createContext();

export function NewsProvider({ children }) {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchNews = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await apiHelper.fetchJSONData('getAllNews');
      if (res && res.news) setNews(res.news);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchNews();
  }, [fetchNews]);

  const value = useMemo(() => ({ news, loading, error, reloadNews: fetchNews }), [news, loading, error, fetchNews]);

  return (
    <NewsContext.Provider value={value}>
      {children}
    </NewsContext.Provider>
  );
}

export function useNews() {
  return useContext(NewsContext);
}